import React, { useEffect } from 'react';
import Header from './components/Header';
import HeroSection from './components/HeroSection';
import FeaturesSection from './components/FeaturesSection';
import WhyUsSection from './components/WhyUsSection';
import CTASection from './components/CTASection';
import Footer from './components/Footer';
import { observeSections } from './analytics';
import './App.css';

function App() {
  useEffect(() => {
    return observeSections();
  }, []);

  return (
    <div className="App">
      <Header />
      <HeroSection />
      <FeaturesSection />
      <WhyUsSection />
      <CTASection />
      <Footer />
    </div>
  );
}

export default App;
